import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';
import type { Assignment, Job } from '@/types/worker';

interface AssignmentDetail {
    assignment: Assignment;
    job: Job;
}

export const useAssignment = (assignmentId: string) => {
    return useQuery({
        queryKey: WORKER_KEYS.assignment(assignmentId),
        enabled: !!assignmentId,
        queryFn: async (): Promise<AssignmentDetail> => {
            const { data } = await api.get(API_ROUTES.workerAssignmentDetail(assignmentId));
            return data;
        },
        staleTime: 30 * 1000,
    });
};
